import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { logError } from "@entrilia/shared/logging";
import { stringComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import biApi from "../../../../api/biApi";
import type { SelectOption } from "../../../common/filters/filterTypes";

const getWorkbookTemplates = withErrorHandling(biApi.getAllWorkbookTemplates);

const getTemplates = async () => {
  const [templates, error] = await getWorkbookTemplates();
  if (error) {
    logError(error, "[getSelectOptions] getWorkbookTemplates");
    return [];
  }
  return templates.map((t) => ({ value: t.id, label: t.name })).sort(stringComparerBy((c) => c.label));
};

export const workbookRunsSelectOptionsResolver = async (filterId: string): Promise<SelectOption[]> => {
  switch (filterId) {
    case "templateId":
      return getTemplates();
    default: {
      logError(`Unknown async select filterId: ${filterId}`, "[getSelectOptions]");
      return [];
    }
  }
};
